export enum DeliveryInfoValidationCode {
  Ok = 'ok',
  ViolationOfLimit = 'violationOfLimit',
  RequestIsEmpty = 'requestIsEmpty',
}

export enum DeliveryValidationResult {
  Available = 'available',
  Unavailable = 'unavailable',
  NotFound = 'notFound',
  WrongFormat = 'wrongFormat',
  Duplicate = 'duplicate',
  InvalidQuantity = 'invalidQuantity',
  InvalidDate = 'invalidDate',
}

export interface DeliveryRowValidation {
  rowNumber: number;
  productSizeId?: string;
  validationResult?: DeliveryValidationResult;
}
